const params = new URLSearchParams(window.location.search);

const src = params.get('src')?.toLowerCase();

export const shouldPartnerRedirect: boolean = src === 'gol';

const ENVIRONMENT_ENUM = [
  'https://localhost',
  'https://dev-b2c.voegol.cloud',
  'https://hom-venda-b2c.voegol.com.br',
  'https://hom-tsts-venda-b2c.voegol.com.br',
  'https://hom-b2c.voegol.com.br',
  'https://hom-vcliente-b2c.voegol.com.br',
  'https://hom-minhasviagens-b2c.voegol.com.br',
  'https://sus-b2c.voegol.com.br',
  'https://hom-checkin-b2c.voegol.com.br',
  'https://hom-financeiro-b2c.voegol.com.br',
  'https://hom-posvenda-b2c.voegol.com.br',
  'https://hom-regressivo-b2c.voegol.com.br',
  'https://b2c.voegol.com.br',
];

const getCallbackEnvironment = (): string => {
  const cbkParam = params.get('cbk');

  if (!cbkParam) {
    return ENVIRONMENT_ENUM[12];
  }

  const cbk = Number(cbkParam);

  return ENVIRONMENT_ENUM[cbk];
};

export const redirectToGol = (): string => {
  return getCallbackEnvironment();
};
